import { render, staticRenderFns } from "./WalletsList.vue?vue&type=template&id=b3a419b0&scoped=true&"
import script from "./WalletsList.vue?vue&type=script&lang=js&"
export * from "./WalletsList.vue?vue&type=script&lang=js&"
import style0 from "./WalletsList.vue?vue&type=style&index=0&id=b3a419b0&lang=scss&scoped=true&"
import style1 from "./WalletsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a419b0",
  null
  
)

export default component.exports